export default __webpack_public_path__ + "static/media/uploader-abbottLibre-problem-1.573adc97.png";